var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSelectPicker24 = function SvgSelectPicker24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.09 3.251a.817.817 0 0 0-1.18 0L7.745 7.537a.875.875 0 0 0 0 1.212.817.817 0 0 0 1.179 0l3.577-3.68 3.577 3.68a.817.817 0 0 0 1.179 0 .874.874 0 0 0 0-1.212L13.089 3.25ZM8.922 14.293c-.326-.39-.853-.39-1.179 0a1.146 1.146 0 0 0 0 1.414l4.167 5c.325.39.853.39 1.178 0l4.167-5a1.146 1.146 0 0 0 0-1.414c-.326-.39-.853-.39-1.179 0L12.5 18.586l-3.577-4.293Z"
  })));
};
export default SvgSelectPicker24;